<template>
  <div :class="$forms.authWindow">
    <div :class="$forms.authLogo">
      <app-logo />
    </div>
    <div :class="$style.message">
      <p v-html="getMessage" />
      <router-link :to="{ name: 'admin' }"> Go to admin page </router-link>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      message:
        'Error 403 – Forbidden. You don’t have permission to access on this page',
    };
  },
  computed: {
    getMessage() {
      return this.message;
    },
  },
  created() {
    // eslint-disable-next-line no-underscore-dangle
    this.message = `Error 403 – Forbidden. You don’t have permission to get URL ${this.$router.history._startLocation}`;
  },
};
</script>

<style src="@/styles/forms.scss" lang="scss" module="$forms"></style>
<style lang="scss" module>
.message {
  padding: 50px;
  text-align: center;
}
</style>
